import { render, staticRenderFns } from "./AamsQualificationRegChange.vue?vue&type=template&id=0f64561a&scoped=true&"
import script from "./AamsQualificationRegChange.vue?vue&type=script&lang=js&"
export * from "./AamsQualificationRegChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f64561a",
  null
  
)

export default component.exports